import { DueDateReccuring } from "../../../../models"

export const UPDATE_DOCUMENT_SCHEDULE_LOCALLY = 'UPDATE_DOCUMENT_SCHEDULE_LOCALLY'

type DocumentSchedule = {
    dueDateUTCDone?: string | null
    dateTimeTo?: string
    dateTimeFrom? : string
    taskDueDateDone: boolean
    dueDateUTC?: Date
    dueDateRecurring?: DueDateReccuring
}

type ar = DocumentSchedule | undefined
export interface DocumentScheduleAction {
    type: string
    docId: string
    payload: DocumentSchedule
}


export const updateDocumentScheduleLocally = (documentSchedule: DocumentSchedule ,docId: string) : DocumentScheduleAction =>  {
    return { 
        type: UPDATE_DOCUMENT_SCHEDULE_LOCALLY, 
        docId,
        payload: documentSchedule,
    }
}